module.exports = __webpack_public_path__ + "static/media/img_dance03.af0bb7a1.png";